// extracted by mini-css-extract-plugin
export default {"p_tye":"dc6365314b","slcted":"_20adc603ce","slc_color":"_2d33a3cb82","item_p":"_180d8127d7","r0":"_77a98de96d"};